import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import "react-bootstrap-multiselect/css/bootstrap-multiselect.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-dropdown-tree-select/dist/styles.css";
import { toast } from "react-toastify";
import LoggedInLayout from "../components/LoggedInLayout";
import PageLoader from "../components/PageLoader";
import PaginationTable from "../components/PaginationTable";
import PeriodDropdown from "../components/PeriodDropdown";
import { Constants } from "../libs/Constants";
import {
  calcuateTaablRefundDue,
  calculateEquivalentShares,
  calculateMaxContribution,
  calculatePurchaseShares,
  calculateTaxes,
  getPurchasePeriodsAsArray,
} from "../libs/contributionLib";
import { getList } from "../libs/dbFunctions";
import {
  convertToCents,
  convertToDollar,
  convertUTCDateInTimeZone,
  formatCurrency,
  numberWithCommas,
  round,
  roundToDigit,
} from "../libs/utils";
import "./ExpenseDashboard.scss";
const moment = require("moment");
const dateFormat = Constants.DATEFORMAT.DDMMYYYY;
const periodOptions = [
  {
    key: Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE,
    value: Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE,
    children: [],
  },
];
const columns = [
  {
    dataField: "empid",
    text: "Employee ID",
    sort: true,
    classes: "p-1",
    footer: "Totals",
  },
  {
    dataField: "firstName",
    sort: true,
    headerStyle: () => {
      return { width: "150px" };
    },
    text: "First Name",
    footer: "",
    classes: "p-1",
    hidden: false,
  },
  {
    dataField: "lastName",
    sort: true,
    headerStyle: () => {
      return { width: "150px" };
    },
    text: "Last Name",
    footer: "",
    classes: "p-1",
  },
  {
    dataField: "totalContributionValue",
    sort: true,
    text: "Contribution Amount",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(convertToDollar(cell));
    },
    footer: (columnData) =>
      formatCurrency(
        convertToDollar(columnData.reduce((acc, item) => acc + item, 0))
      ),
  },
  {
    dataField: "marketSharePrice",
    sort: true,
    text: "Market Share Price",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(cell);
    },
    footer: "",
  },
  {
    dataField: "purchasePrice",
    sort: true,
    text: "Purchase Price",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(convertToDollar(cell));
    },

    footer: "",
  },
  {
    dataField: "valueOfTaabl",
    sort: true,
    text: "Value Of Taabl",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(convertToDollar(cell));
    },
    footer: (columnData) =>
      formatCurrency(
        convertToDollar(columnData.reduce((acc, item) => acc + item, 0))
      ),
  },
  {
    dataField: "taxesToBePaid",
    sort: true,
    text: "Taxes To Be Paid",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(convertToDollar(cell));
    },
    footer: (columnData) =>
      formatCurrency(
        convertToDollar(columnData.reduce((acc, item) => acc + item, 0))
      ),
  },
  {
    dataField: "amountToBePaid",
    sort: true,
    text: "Amount To Be Paid",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(convertToDollar(cell));
    },
    footer: (columnData) =>
      formatCurrency(
        convertToDollar(columnData.reduce((acc, item) => acc + item, 0))
      ),
  },
  {
    dataField: "sharesPurchansed",
    sort: true,
    text: "Shares Purchased",
    classes: "p-1",
    footer: (columnData) => {
      let totalShares = columnData.reduce((acc, item) => acc + item, 0);
      return numberWithCommas(totalShares.toFixed(2));
    },
  },
  {
    dataField: "sharesToBeSold",
    sort: true,
    text: "Shares To Be Sold",
    classes: "p-1",
    footer: (columnData) => {
      let totalShares = columnData.reduce((acc, item) => acc + item, 0);
      return numberWithCommas(totalShares.toFixed(2));
    },
  },
  {
    dataField: "netEmployeeShare",
    sort: true,
    text: "Net Employee Share",
    classes: "p-1",
    formatter: (cell) => {
      return roundToDigit(cell);
    },
    footer: (columnData) =>
      numberWithCommas(
        roundToDigit(columnData.reduce((acc, item) => acc + item, 0))
      ),
  },
  {
    dataField: "valueOfEmployee",
    sort: true,
    text: "Value Of Employee",
    classes: "p-1",
    formatter: (cell) => {
      return formatCurrency(cell);
    },
    footer: (columnData) =>
      formatCurrency(columnData.reduce((acc, item) => acc + item, 0)),
  },
  {
    dataField: "taablRefundDue",
    sort: true,
    text: "Taabl Refund Due",
    classes: "p-1",
    formatter: (cell) => {
      if (cell !== "NA") {
        return formatCurrency(convertToDollar(cell));
      }
      return cell;
    },
    footer: (columnData) => {
      return formatCurrency(
        convertToDollar(
          columnData.reduce((acc, item) => {
            if (item === "NA") {
              return acc;
            } else {
              return acc + item;
            }
          }, 0)
        )
      );
    },
  },
  {
    dataField: "taablRefundReason",
    sort: true,
    text: "Taabl Refund Reason",
    footer: "",
  },
  {
    dataField: "withdrawDate",
    sort: true,
    text: "Withdrawn/Terminated",
    formatter: (cell) => {
      if (cell !== "NA") {
        return moment(cell).format(dateFormat);
      }
      return cell;
    },
    footer: "",
  },
];

const PeriodEndReport = (props) => {
  const [periods, setPeriods] = useState([]);
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contributions, setContributions] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [currentPageSize, setCurrentPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastKey, setLastKey] = useState(null);
  const [lastFilterOptions, setLastFilterOptions] = useState({});

  useEffect(() => {
    let totalLoaded = contributions.length;
    let totalPages = totalLoaded / currentPageSize;
    let needMoreRecords = totalPages - currentPage < 4 && !!lastKey;
    if (needMoreRecords) {
      loadContribution(null, true);
    }
  }, [currentPage, currentPageSize]);
  useEffect(() => {
    async function load() {
      props.setPageLoading(true);
      let promises = [getPlan(), loadPeriods()];
      await Promise.all(promises);
      props.setPageLoading(false);
    }
    load();
  }, []);

  useEffect(() => {
    processContributions();
  }, [contributions]);

  function processContributions() {
    setLoading(true);
    if (contributions && contributions.length > 0) {
      const feeRatePercentage = Constants.FEE_RATE / 100;
      const taxPercentage = Constants.TAX_RATE / 100;
      let filteredContributions = [];
      for (let contribution of contributions) {
        let purchasePeriods = getPurchasePeriodsAsArray(contribution, false);
        let totalContributionValue = 0;
        let withdrawDate = null;
        for (let purchasePeriod of purchasePeriods) {
          for (let c of purchasePeriod) {
            switch (c.type) {
              case Constants.CONTRIBUTION_STATUS.NEW:
              case Constants.CONTRIBUTION_STATUS.INCREASE:
              case Constants.CONTRIBUTION_STATUS.RESET_NEW:
                totalContributionValue += c.contributionValue;
                break;
              case Constants.CONTRIBUTION_STATUS.DECREASE:
              case Constants.CONTRIBUTION_STATUS.WITHDRAW:
                withdrawDate = c.modificationDate;
                break;
              case Constants.CONTRIBUTION_STATUS.TERMINATE:
                withdrawDate = c.modificationDate;
                totalContributionValue += c.contributionValue;
                break;
            }
          }
        }
        let purchasePrice = contribution?.purchasePrice;
        let taablMaxShare;
        if (plan?.maxContribution?.stock) {
          taablMaxShare = plan?.maxContribution?.stock;
        } else {
          taablMaxShare =
            convertToCents(
              calculateMaxContribution(
                plan?.maxContribution,
                plan?.purchasePeriod
              )
            ) / purchasePrice;
        }
        let fractionalShareValue = calculatePurchaseShares(
          totalContributionValue,
          purchasePrice
        );
        let sharesPurchansed = Math.min(
          taablMaxShare,
          calculateEquivalentShares(totalContributionValue, purchasePrice, plan)
        );
        let taxesToBePaid = calculateTaxes(
          totalContributionValue,
          feeRatePercentage,
          taxPercentage
        );
        let valueOfTaabl = (1 + feeRatePercentage) * totalContributionValue;
        let amountToBePaid = valueOfTaabl + taxesToBePaid;
        let stockPrice = contribution?.stockPrice;
        let marketSharePrice = selectedPeriod?.stockPrice;
        if (marketSharePrice) {
          stockPrice = convertToCents(marketSharePrice);
        }
        let sharesToBeSold = Math.floor(amountToBePaid / stockPrice);
        let netEmployeeShare = sharesPurchansed - sharesToBeSold;

        let valueOfEmployee = netEmployeeShare * marketSharePrice;
        let { taablRefundDue, taablRefundReason } = calcuateTaablRefundDue(
          taablMaxShare,
          totalContributionValue,
          fractionalShareValue,
          sharesPurchansed,
          purchasePrice,
          plan
        );
        let userDetails = Object.assign(
          { ...contribution },
          {
            sharesPurchansed,
            totalContributionValue,
            sharesNeeded: "NA",
            amountToBePaid,
            taxesToBePaid,
            valueOfTaabl,
            sharesToBeSold,
            netEmployeeShare,
            marketSharePrice,
            valueOfEmployee,
            taablRefundDue,
            taablRefundReason,
            withdrawDate: withdrawDate !== null ? withdrawDate : "NA",
          }
        );
        // Setting load amount needed
        // Check if we have period end stock price
        if (
          selectedPeriod.stockPrice &&
          userDetails.totalContributionValue > 0
        ) {
          let profit =
            (selectedPeriod.stockPrice -
              convertToDollar(userDetails.purchasePrice)) *
            userDetails.shares;
          userDetails.sharesNeeded = round(
            userDetails.shares + profit / selectedPeriod.stockPrice
          );
        }
        filteredContributions.push(userDetails);
      }
      setTableData(filteredContributions);
    } else setTableData([]);
    setLoading(false);
  }
  const contentTable = ({ paginationTableProps }) => {
    return (
      <PageLoader isActive={loading}>
        <BootstrapTable
          bootstrap4={true}
          wrapperClasses="table-vw-height mb-2"
          classes="table-taabl"
          keyField="id"
          bordered={false}
          data={tableData}
          noDataIndication={() => <div>No data found</div>}
          columns={columns}
          {...paginationTableProps}
        />
      </PageLoader>
    );
  };
  async function loadPeriods() {
    try {
      let periods = await getList(
        Constants.dbTypes.PERIOD,
        props.activeCompany
      );
      if (periods && periods.length > 0) {
        let now = convertUTCDateInTimeZone(
          moment.utc().valueOf(),
          props.activeCompany.timezone
        );
        // Filter past periods
        periods = periods.filter((p) => p.periodEnddate <= now.valueOf());
        setPeriods(periods);
      }
    } catch (e) {
      toast.error(e);
    }
  }
  async function getPlan() {
    try {
      const planDetail = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        props.activeCompany
      );
      if (planDetail && planDetail.length > 0) {
        setPlan(planDetail[0]);
      }
    } catch (e) {
      toast.error(e);
    }
  }

  async function loadContribution(filter, reloadContributions = false) {
    if (reloadContributions === true) {
      filter = lastFilterOptions;
    } else {
      setLastFilterOptions(filter);
    }
    filter = { ...filter, pagination: true, lastKey: lastKey ? lastKey : null };
    setLoading(true);
    try {
      let contributionsResult = await getList(
        Constants.dbTypes.OFFERING_PERIOD_CONTRIBUTIONS,
        props.activeCompany,
        filter
      );
      if (contributionsResult?.lastKey) {
        setLastKey(contributionsResult.lastKey);
      }
      if (contributionsResult && contributionsResult.length > 0) {
        setContributions([...contributions, ...contributionsResult]);
      } else {
        setContributions([]);
      }
    } catch (e) {
      toast.error(e);
    }

    setLoading(false);
  }

  function handlePeriodSelect(sPeriod) {
    setSelectedPeriod(sPeriod.period);
    if (sPeriod && sPeriod?.type) {
      switch (sPeriod.type) {
        case Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION:
          loadContribution({
            offerStartdate: sPeriod?.period?.periodStartdate,
          });
          break;
        case Constants.PERIOD_DISPLAY_TYPES.PURCHASE:
          loadContribution({
            periodStartdate: sPeriod.period.periodStartdate,
            periodEnddate: sPeriod.period.periodEnddate,
          });
          break;
      }
    }
  }

  function renderContributions() {
    return (
      <PaginationTable
        onPageChange={setCurrentPage}
        onPageSizeChange={setCurrentPageSize}
        totalRow={tableData?.length}
      >
        {contentTable}
      </PaginationTable>
    );
  }
  return (
    <LoggedInLayout title="Taabl Summary Report">
      {periods && plan && (
        <Row className="ms-0">
          {periods.length > 0 && (
            <PeriodDropdown
              periods={periods}
              plan={plan}
              options={periodOptions}
              handlePeriodSelect={handlePeriodSelect}
              activeCompany={props.activeCompany}
            ></PeriodDropdown>
          )}
          {periods.length === 0 && <span>You do not have any periods</span>}
        </Row>
      )}
      {renderContributions()}
    </LoggedInLayout>
  );
};

export default PeriodEndReport;
